var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 20.8037H16.6797V31.4912H8.47656C7.42656 31.4912 6.5625 30.6025 6.5625 29.5225V20.8037Z",
    fill: "url(#paint0_linear_115_6853)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 20.8037V29.5225C28.4375 30.6025 27.5734 31.4912 26.5234 31.4912H18.3203V20.8037H28.4375Z",
    fill: "url(#paint1_linear_115_6853)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 14.335V17.1475C4.375 18.2275 5.23906 19.1162 6.28906 19.1162H6.5625H16.6797V17.4287V12.3662H6.28906C5.23906 12.3662 4.375 13.255 4.375 14.335Z",
    fill: "url(#paint2_linear_115_6853)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7109 12.3662H18.3203V17.4287V19.1162H28.4375H28.7109C29.7609 19.1162 30.625 18.2275 30.625 17.1475V14.335C30.625 13.255 29.7609 12.3662 28.7109 12.3662Z",
    fill: "url(#paint3_linear_115_6853)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 13.5406C17.2615 13.5406 17.034 13.4337 16.8798 13.2481C16.7234 13.0624 16.6544 12.8161 16.6884 12.5731C17.093 9.76056 19.2291 4.44043 24.4223 4.44043C27.3863 4.44155 28.4374 6.08855 28.4374 7.49931C28.4374 10.0069 25.0435 13.5406 17.4999 13.5406ZM24.4223 6.12905C20.5044 6.12905 19.0169 9.95968 18.5237 11.8283C21.6146 11.6798 23.5637 10.8754 24.6859 10.1903C26.2423 9.23968 26.7968 8.17655 26.7968 7.49818C26.7968 6.48793 25.5707 6.12905 24.4223 6.12905Z",
    fill: "url(#paint4_linear_115_6853)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.501 13.5407C9.95738 13.5407 6.56348 10.007 6.56348 7.49942C6.56348 6.08867 7.61566 4.44167 10.5797 4.44167C15.7718 4.44167 17.9079 9.76179 18.3125 12.5743C18.3464 12.8173 18.2775 13.0637 18.1211 13.2493C17.9669 13.4338 17.7394 13.5407 17.501 13.5407ZM10.5797 6.12917C9.43129 6.12917 8.2041 6.48917 8.2041 7.49942C8.2041 8.93604 10.6464 11.5539 16.4761 11.8295C15.9839 9.95979 14.4964 6.12917 10.5797 6.12917Z",
    fill: "url(#paint5_linear_115_6853)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_6853",
    x1: 6.5625,
    y1: 26.1475,
    x2: 16.6797,
    y2: 26.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_6853",
    x1: 18.3203,
    y1: 26.1475,
    x2: 28.4375,
    y2: 26.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_6853",
    x1: 4.375,
    y1: 15.7412,
    x2: 16.6797,
    y2: 15.7412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_115_6853",
    x1: 18.3203,
    y1: 15.7412,
    x2: 30.625,
    y2: 15.7412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_115_6853",
    x1: 6.56348,
    y1: 8.99055,
    x2: 28.4374,
    y2: 8.99055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_115_6853",
    x1: 6.56348,
    y1: 8.99055,
    x2: 28.4374,
    y2: 8.99055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.07dbe52fd0a8656ff7ca7500cb20523d.svg";
export { ForwardRef as ReactComponent };